import "../css/connections.css";
import "../css/button.css";
import commoncss from "../css/common.module.css";
import buttoncss from "../css/button.module.css";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Table from "../elements/Table";
import {Button} from "../elements/Button";
import Modal from "../elements/Modal";
import StatusIndicator from "../elements/StatusIndicator";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";
import fscp_posting_view from "../data/fscp_posting_view.json";
import DefaultUser from "../assets/imgs/default_user.png";
import User2 from "../assets/imgs/user2.png";
import Dropdown from "./../elements/Dropdown";
import InputGroup from "./../elements/InputGroup";
import Breadcrumb from "./../components/Breadcrumb";

export default function FscpPostingView() {
  const [displayModal, setDisplayModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);

  const breadcrumbItems = [
    {
      label: "Workspace name",
      link: "/myfinV2/book-closure",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Book Closure name",
      link: "/myfinV2/book-closure",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "View FSCP Posting", link: "", className: "headerLable" },
  ];

  const breadcrumbAdditionalLinks = [
    {
      label: "View Logs",
      link: "/myfinv2/book-closure/fscp-posting-logs",
      className: `additionalLinks clickable`,
    }
  ];

  const th_data = [
    { header: <input type="checkbox" value="" key="" />, accessor: "checkbox" },
    { header: "S.NO", accessor: "s_no" },
    { header: "LEDGER CODE", accessor: "ledger_code" },
    { header: "LEDGER NAME", accessor: "ledger_name" },
    { header: "AMOUNT", accessor: "amount" },
    { header: "ASSIGNEE", accessor: "preparer" },
    { header: "APPROVER", accessor: "approver" },
    { header: "REMARKS", accessor: "remarks" },
    { header: "MODULE", accessor: "module" },
  ];

  const tr_data = fscp_posting_view.map((item, i) => ({
    checkbox: (
      <input type="checkbox" value={item.ledger_code} key={`checkbox-${i}`} />
    ),
    s_no: i + 1,
    ledger_code: item.ledger_code,
    ledger_name: item.ledger_name,
    amount: `${item.amount}`,
    remarks: item.remarks,
    preparer: (
      <>
        <img className="card-user-img vaMiddle" src={User2} alt="user_image" />
        &nbsp;Jane Doe
      </>
    ),
    approver: (
      <>
        <img
          className="card-user-img vaMiddle"
          src={DefaultUser}
          alt="user_image"
        />
        &nbsp;Nimi
      </>
    ),
    module: item.module,
  }));

  const handleClose = () => {
    setDisplayModal(false);
  };

  return (
    <>
      <div className="connections-wrapper">
        <Breadcrumb
          items={breadcrumbItems}
          additionalLinks={breadcrumbAdditionalLinks}
          headerActions={
            <>
              <SearchIcon />
              &ensp;&nbsp;
              <FilterIcon
                className="clickable-icon mr-15"
                onClick={() => {
                  setFilterModal(true);
                  setDisplayModal(true);
                }}
                height={20}
              />
              &nbsp;
              <Button
                btnColor={buttoncss.secondary}
                label="Create Push Package"
              />
              &ensp;
              <Button btnColor={buttoncss.secondary} label="View Matrix" />
              &ensp;
              <Button btnColor={buttoncss.primary} label="Export to Excel" />
            </>
          }
        />
        <div className="connections-content info-content">
          <main>
            <Table columns={th_data} data={tr_data} />
            {/* <PaginationFooter /> */}
          </main>
        </div>
      </div>
      {filterModal && displayModal && (
        <Modal
          title="Filters"
          headerActions={
            <lable className="primaryLable clickable">Reset Filters</lable>
          }
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={() => {
                  handleClose();
                  setFilterModal(false);
                }}
                label="Cancel"
              />
              <span>
                <Button btnColor={buttoncss.secondary} label="Custom Filter" />
                &ensp;
                <Button btnColor={buttoncss.primary} label="Apply Filter" />
              </span>
            </>
          }
          onClose={() => console.log("Modal Closed")}
        >
          <InputGroup
            inputs={[
              <>
                <Dropdown
                  label="Ledger Code"
                  options={["TB001", "GL002"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Code"}
                />
              </>,
              <>
                <Dropdown
                  label="Ledger Name"
                  options={["Trial Balance", "General Ledger"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Name"}
                />
              </>,
            ]}
          />

          <Dropdown
            label="Preparer"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Preparer"}
          />

          <Dropdown
            label="Approver"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Approver"}
          />
        </Modal>
      )}
    </>
  );
}
